import { navigate } from "gatsby";

export function safeNavigate(to) {
    const isBrowser = typeof window !== "undefined"
    if (isBrowser) {
        navigate(to);
    }
}